import { render, staticRenderFns } from "./BoardCardsExport.vue?vue&type=template&id=54b3b44d&scoped=true&"
import script from "./BoardCardsExport.vue?vue&type=script&lang=js&"
export * from "./BoardCardsExport.vue?vue&type=script&lang=js&"
import style0 from "./BoardCardsExport.vue?vue&type=style&index=0&id=54b3b44d&prod&scoped=true&lang=css&"
import style1 from "./BoardCardsExport.vue?vue&type=style&index=1&id=54b3b44d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3b44d",
  null
  
)

export default component.exports